import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { countries } from '../../../../assets/utils/lada';
import { FormControl } from '@angular/forms';
import { PuzzleService } from 'src/app/services/puzzle.service';
import { MatSelectChange } from '@angular/material/select';

interface Country {
  lada: string;
  country: string;
  code: string;
}

@Component({
  selector: 'app-phone-lada-select',
  templateUrl: './phone-lada-select.component.html',
  styleUrls: ['./phone-lada-select.component.css'],
})
export class PhoneLadaSelectComponent implements OnInit, OnChanges {
  @Input() placeholder: string = '';
  @Input() tabindex1: number = 0;
  @Input() tabindex2: number = 0;
  @Input() phone: string = '';
  @Input() disabled: boolean = false;
  @Input() maxlength: number = 10;
  @Input() defaultlada: string;

  @Output() phoneval = new EventEmitter<any>();
  @Output() ladaval = new EventEmitter<any>();
  customclass: string = 'phone-border';

  lada: any = '52';
  value: string = '';
  countries = countries;
  filteredCountries: any[] = [];
  ladaSearchControl = new FormControl();

  constructor(private puzzleService: PuzzleService) {}

  ngOnInit(): void {
    this.phone = this.transformValueNumber(this.phone);
    this.getCountryPhoneCodes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Verifica si el valor de phone ha cambiado
    if (changes.phone && !changes.phone.firstChange) {
      this.initializeValues();
    }

    //actualizar lada
    if (changes.defaultlada && !changes.defaultlada.firstChange) {
      this.lada = this.countries.find(
        (country: any) =>
          this.removeSymbolAndSpace(country.crcC_CODE) === this.defaultlada,
      );
    }
  }

  initializeValues() {
    let numberDigits = 10;
    if (this.lada?.digiT_MAX) {
      numberDigits = this.lada.digiT_MAX;
    }
    if (this.phone && this.phone.length > 0) {
      if (!this.lada?.digiT_MAX) {
        const phoneLength = this.phone.length;
        // si el numero empieza con 55, 49, 54, 98, 20 y tiene mas de 10 digitos es numero de 11 ditios
        if (
          (this.phone.startsWith('55') ||
            this.phone.startsWith('49') ||
            this.phone.startsWith('54') ||
            this.phone.startsWith('98') ||
            this.phone.startsWith('20')) &&
          phoneLength > 11
        ) {
          numberDigits = 11;
        } else if (
          (this.phone.startsWith('598') ||
            this.phone.startsWith('373') ||
            this.phone.startsWith('994')) &&
          phoneLength > 11
        ) {
          numberDigits = 9;
        } else if (
          (this.phone.startsWith('374') ||
            this.phone.startsWith('856') ||
            this.phone.startsWith('216')) &&
          phoneLength > 10
        ) {
          numberDigits = 8;
        }
      }

      // obtener numero sin lada
      this.value = this.phone.slice(-numberDigits);
      // obtener lada
      const lada = this.phone.slice(0, this.phone.length - numberDigits);

      if (this.phone.length > numberDigits) {
        this.lada = this.countries.find(
          (country: any) =>
            this.removeSymbolAndSpace(country.crcC_CODE) === lada,
        );
      }
    }

    if (!this.lada?.crcC_CODE) {
      if (this.defaultlada) {
        this.lada = this.countries.find(
          (country: any) =>
            this.removeSymbolAndSpace(country.crcC_CODE) === this.defaultlada,
        );
      } else {
        this.lada = this.countries.find(
          (country: any) =>
            this.removeSymbolAndSpace(country.crcC_CODE) === '+52',
        );
      }
    }

    this.sendValue();
  }

  sendValue(event?: any) {
    if (event) {
      this.lada = event.value;
    }

    if(this.lada?.crcC_CODE){
      this.ladaval.emit(this.lada);
    }

    if (this.value == null || this.value == undefined || this.value == '') {
      this.phoneval.emit(null);
      return;
    }

    let numberDigits = 10;
    if (this.lada?.digiT_MAX) {
      numberDigits = this.lada.digiT_MAX;
    }

    if (this.value.length < numberDigits) {
      this.phoneval.emit(this.value);
      return;
    }
    const phoneWithLada =
      this.removeSymbolAndSpace(this.lada.crcC_CODE) + this.value;
    this.phoneval.emit(phoneWithLada);
  }

  private transformValueNumber(value: string): string {
    if (value == null) {
      return '';
    }
    return value.replace(/[^0-9]/g, '').trimStart();
  }

  onFocus() {
    this.customclass = 'phone-border-focus';
  }

  onBlur() {
    this.customclass = 'phone-border';
  }

  getCountryPhoneCodes() {
    this.puzzleService.getCountryPhoneCodes().subscribe((response) => {
      this.countries = response;

      this.filteredCountries = this.countries;

      this.ladaSearchControl.valueChanges.subscribe((search) => {
        this.filteredCountries = this.countries.filter((element: any) =>
          `${element.ctR_NAME} (${element.crcC_CODE})`
            .toLowerCase()
            .includes(search?.toLowerCase() || ''),
        );
      });

      this.initializeValues();
    });
  }

  removeSymbolAndSpace(value: string): string {
    return value.replace(/[^0-9]/g, '').replace(/\s+/g, '');
  }
}
